import { LeadDestinations } from '../types/lead-destinations';

export const destinationNames: Record<LeadDestinations, string> = {
  rex_crm: 'Rex CRM',
  email_address: "Agent / Agency's email address"
};

export const getDestinationName = (destination: LeadDestinations): string =>
  destinationNames[destination];
